module.exports = __webpack_public_path__ + "img/informasi.366bc723.svg";